import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'
import { PropertyEvent } from '../types/propertyEvent'

interface GetEventsParams {
    time?: 'upcoming' | 'past'
    apartment_id?: number
    starts_after?: string
    starts_before?: string
}

export const useEvents = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [eventList, setEventList] = useState<PropertyEvent[]>([])
    const [selectedEvent, setSelectedEvent] = useState<PropertyEvent | null>(
        null,
    )
    const [hasError, setHasError] = useState(false)

    const getEvents = async (params?: GetEventsParams) => {
        setIsLoading(true)
        setHasError(false)
        try {
            const res = await axiosInstance.get<PropertyEvent[]>(
                'beta/api/ezos-calendar/property-events/tenant/',
                { params },
            )
            setEventList(res.data)
            setIsLoading(false)
            return res.data
        } catch (e) {
            toast.error('Error loading events')
            setHasError(true)
            setIsLoading(false)
            return Promise.reject(e)
        }
    }

    const getEventDetail = async (id: number) => {
        setIsLoading(true)
        setHasError(false)
        try {
            const res = await axiosInstance.get<PropertyEvent>(
                `beta/api/ezos-calendar/property-events/tenant/${id}/`,
            )
            setSelectedEvent(res.data)
            setIsLoading(false)
            return res.data
        } catch (e) {
            toast.error('Error loading event details')
            setHasError(true)
            setIsLoading(false)
            return Promise.reject(e)
        }
    }

    return {
        isLoading,
        hasError,
        eventList,
        selectedEvent,
        getEvents,
        getEventDetail,
    }
}
